import { companyApis } from '@apis/dashboard/companyApis';
import { useMutation } from '@hooks/useMutation';

export const useResendEmail = () => {
  return useMutation(async (body: { email: string }) => {
    const response = await companyApis.post('/dashboard/company/staff/resend-email/', { body });
    return response[200]!;
  });
};
